import {del, get, patch, post, put} from './http'
/*******************************商品详情*****************************************/

/**
 * 商品列表 ProductList 2019.7.10
 * zgh:::404
 */
// export const getProductList = {}
// export const getProductList = (params) => get('goodsmanual/goods/list', params)
// https://api.fat.laodao.co/tradeapp/goods/ent/list?pageSize=30&pageNum=1&goodsName=sss&token=J5pXuAp4cHlgz9AfQA0tw
export const getProductList = (params) => get('tradeapp/goods/ent/list', params)

/**
 * 新增商品 ProductInfo  2019.7.10
 */
export const addProduct = (params) => post('goodsmanual/goods', params)

/**
 * 商品详情 ProductInfo  2019.7.11
 */
export const getProductInfo = (goodsId) => get('goodsmanual/goods/' + goodsId, {})

/**
 * 新版获取商品详情
 * @param goodsId
 */
export const getProductDetail = (goodsId) => get('goodsmanual/goods/news/' + goodsId, {})
/**
 * 编辑商品 ProductInfo  2019.7.11
 */
export const editProduct = (goodsId, params) => patch('goodsmanual/goods/' + goodsId, params)

/**
 * 批量删除商品 ProductList  2019.7.11
 */
export const delBatchProduct = (params) => del('goodsmanual/goods', params)

export const copyProduct = (params) => post('goodsmanual/goods/copy', params)

/*******************************商品登记信息*****************************************/
/**
 * 新增登记信息 ProductRegisterInfo 2019.7.11
 */
export const addProductRegisterInfo = (params) => post('goodsmanual/goods/info', params)

/**
 * 登记信息列表 ProductRegisterInfo 2019.7.11
 */
export const getProductRegisterList = (params) => get('goodsmanual/goods/ingredient', params)

/**
 * 编辑登记信息 ProductRegisterInfo 2019.7.11
 */
export const editProductRegisterInfo = (params) => patch('goodsmanual/goods/ingredient', params)

/**
 * 删除登记信息 ProductRegisterInfo 2019.7.11
 */
export const delProductRegisterInfo = (params) => del('goodsmanual/goods/info', params)

/*******************************商品配方成份/含量指标*****************************************/
/**
 * 新增配方成分 ProductIndicators 2019.7.12
 */
export const addProductIngredientInfo = (params) => post('goodsmanual/goods/ingredient', params)

/**
 * 配方成分列表 ProductIndicators 2019.7.12
 */
export const getProductIndicators = (params) => get('goodsmanual/goods/ingredient', params)

/**
 * 编辑配方成分 ProductIndicators 2019.7.12
 */
export const editProductIngredientInfo = (params) => patch('goodsmanual/goods/ingredient', params)

/**
 * 删除配方成分 ProductIndicators 2019.7.12
 */
export const delProductIndicatorsInfo = (params) => del('goodsmanual/goods/ingredient', params)

/**
 * 成分排序
 * @param params
 */
export const sortProductIndicators = (params) => patch('goodsmanual/goods/ingredient/sort', params)

/*******************************商品理化指标*****************************************/
/**
 * 新增理化指标 ProductPhysicochemical 2019.7.15
 */
export const addProductPhysicochemical = (params) => post('goodsmanual/goods/index', params)

/**
 * 理化指标列表 ProductPhysicochemical 2019.7.15
 */
export const getProductPhysicochemicals = (params) => get('goodsmanual/goods/index', params)

/**
 * 编辑理化指标 ProductPhysicochemical 2019.7.15
 */
export const editProductPhysicochemical = (params) => patch('goodsmanual/goods/index', params)

/**
 * 删除理化指标 ProductPhysicochemical 2019.7.15
 */
export const delProductPhysicochemical = (params) => del('goodsmanual/goods/index', params)

/*******************************商品功能特点*****************************************/
/**
 * 新增功能特点 ProductFunction 2019.7.12
 */
export const addProductFunctionInfo = (params) => post('goodsmanual/goods/features', params)

/**
 * 功能特点列表 ProductFunction 2019.7.12
 */
export const getProductFunctions = (params) => get('goodsmanual/goods/features', params)

/**
 * 编辑功能特点 ProductFunction 2019.7.12
 */
export const editProductFunctionInfo = (featureId, params) => patch('goodsmanual/goods/features/' + featureId, params)

/**
 * 删除功能特点 ProductFunction 2019.7.12
 */
export const delProductFunctionInfo = (params) => del('goodsmanual/goods/features', params)

/*******************************商品产品优势*****************************************/
/**
 * 新增产品优势 ProductMechanism 2019.7.12
 */
export const addProductEffectInfo = (params) => post('goodsmanual/goods/effect', params)

/**
 * 作用产品优势 ProductMechanism 2019.7.12
 */
export const getProductEffects = (params) => get('goodsmanual/goods/effect', params)

/**
 * 编辑产品优势 ProductMechanism 2019.7.12
 */
export const editProductEffectInfo = (mechanismId, params) => patch('goodsmanual/goods/effect/' + mechanismId, params)

/**
 * 删除产品优势 ProductMechanism 2019.7.12
 */
export const delProductEffectInfo = (params) => del('goodsmanual/goods/effect', params)

/*******************************商品产品问答*****************************************/
/**
 * 新增产品问答 ProductQuestion 2019.7.12
 */
export const addProductQuestionInfo = (params) => post('goodsmanual/goods/question', params)

/**
 * 产品问答列表 ProductQuestion 2019.7.12
 */
export const getProductQuestions = (params) => get('goodsmanual/goods/question', params)

/**
 * 编辑产品问答 ProductQuestion 2019.7.12
 */
export const editProductQuestionInfo = (questionId, params) => patch('goodsmanual/goods/question/' + questionId, params)

/**
 * 删除产品问答 ProductQuestion 2019.7.12
 */
export const delProductQuestionInfo = (params) => del('goodsmanual/goods/question', params)

/*******************************技术视频问答*****************************************/
/**
 * 添加技术视频 ProductVideo 2019.7.13
 */
export const addProductVideo = (params) => post('goodsmanual/goods/video', params)

/**
 * 技术视频列表 ProductVideoList 2019.7.13
 */
export const getProductVideos = (params) => get('goodsmanual/goods/video/list', params)

/**
 * 编辑技术视频 ProductVideo 2019.7.13
 */
export const editProductVideo = (params) => patch('goodsmanual/goods/video', params)

/**
 * 删除技术视频 ProductVideoList 2019.7.13
 */
export const delProductVideo = (params) => del('goodsmanual/goods/video', params)

/**
 * 技术视频详情 ProductVideo 2019.7.13
 */
export const getProductVideoDetail = (videoId, params) => get('goodsmanual/goods/video/' + videoId, params)


/*******************************登记证*****************************************/
export const getLicenseListByEntId = (params) => get('goodsmanual/license/list', params)

export const addgoodsmanualLicense = (params) => post('goodsmanual/license', params)


/*******************************应用技术*****************************************/
export const getTechnologyList = (params) => get('goodsmanual/goods/technology', params)

export const addTechnology = (params) => post('goodsmanual/goods/technology', params)

export const editTechnology = (technologyId, params) => patch('goodsmanual/goods/technology/' + technologyId, params)

export const delTechnology = (params) => del('goodsmanual/goods/technology', params)

export const getTechnologydetail = (technologyId) => get('goodsmanual/goods/technology/' + technologyId, {})

/*******************************注意事项*****************************************/
export const addPrecaution = (params) => post('goodsmanual/goods/precaution', params)

export const editPrecaution = (precautionId, params) => patch('goodsmanual/goods/precaution/' + precautionId, params)

export const getPrecaution = (params) => get('goodsmanual/goods/precaution', params)

export const delPrecaution = (params) => del('goodsmanual/goods/precaution', params)

/*******************************中毒急救*****************************************/
export const editAid = (params) => patch('goodsmanual/goods/aid', params)

export const getAidDetail = (params) => get('goodsmanual/goods/aid', params)

/*******************************存储运输*****************************************/
export const editTransport = (params) => patch('goodsmanual/goods/transport', params)

export const getTransport = (params) => get('goodsmanual/goods/transport', params)

/*******************************商品分类*****************************************/
/**
 * zgh::: 404
 */
export const getAllProductClassList = () => get('goodsmanual/goods/class/list', {
  checkStatus: -1
})
/**
 * 选中产品分类
 * zgh::: 404
 */
export const getProductClassList = () => get('goodsmanual/goods/class/list', {
  checkStatus: 1
})

/**
 * 未选中产品分类
 * zgh:::404
 */
export const getSysProClassList = () => get('goodsmanual/goods/class/list', {
  checkStatus: 0
})

/*选择分类*/
export const addGoodClass = (params) => patch('goodsmanual/goods/class/batch', params)

export const newGoodClass = (params) => post('goodsmanual/goods/class', params)

export const editGoodClass = (classId, params) => patch('goodsmanual/goods/class/' + classId, params)

export const delGoodClass = (params) => del('goodsmanual/goods/class', params)

export const getGoodClassDetail = (classId) => get('goodsmanual/goods/class/' + classId, {})

export const formatclass = () => post('goodsmanual/goods/class/init', {})
/*******************************商品剂型*****************************************/
/**
 * 商品剂型
 */
export const getProductFormulationList = () => get('goodsmanual/formulation/detail/list', {})

export const setGoodSpecDefault = (params) => patch('goodsmanual/goods/spec/info/default', params)

export const getUnitList = (formulationId) => get('goodsmanual/unit/list', {
  formulationId: formulationId
})

/**
 * 获取所有包装单位
 */
export const getAllUnitList = () => get('goodsmanual/unit/all', {})


/**
 * 添加剂型
 * @param params
 */
export const addFormulation = (params) => post('goodsmanual/formulation', params)

/**
 * 删除剂型
 * @param params
 */
export const delFormulation = (params) => del('goodsmanual/formulation', params)

/*******************************商品精简版商品*****************************************/

export const addProductSimple = (params) => post('goodsmanual/goods/simple', params)

export const getProductSimpleDetail = (goodsId) => get('goodsmanual/goods/simple/' + goodsId, {})

/*******************************商品上下架*****************************************/
export const shelfgoods = (params) => put('goodsmanual/goods/shelf/goods', params)

/*******************************商品迁移*****************************************/
export const migrateProduct = (params) => patch('goodsmanual/goods/migrate/class', params)

/*******************************商品详情显示类型切换*****************************************/
export const changeGoodsdisplayType = (params) => patch('goodsmanual/goods/info/type', params)


/**
 * 获取产品预览详情
 * @param goodsId
 */
export const getAppProDetail = (goodsId) => get('goodsmanual/goods/preview/' + goodsId, {})


/*******************************商品统计*****************************************/

/**
 * 获取商品统计
 */
export const getgoodsstatistics = (params) => get('goodsmanual/goods/statistics', params)
